import { TwinApi } from '@api/twin/TwinApi';
import { TeiaSearchFilter } from '@stereograph/teia-system-design/utils';
import { useTeiaViewerContext, useTwinSource } from '@stereograph/teiaviewer';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { teiaQuantityTakeoffObjectsDTO } from '../utils/teiaQuantityTakeoffObjectsDTO';
import { teiaQuantityTakeoffQueryKeys } from '../utils/teiaQuantityTakeoffQueryKeys';

export interface UseQuantityTakeoffObjectParams {
  rule: TeiaSearchFilter;
  columns: Array<string>;
  groupBy?: string;
  pageIndex?: number;
  pageSize?: number;
  orderBy?: string;
  orderDirection?: string;
}

export const useQuantityTakeoffObject = (params: UseQuantityTakeoffObjectParams) => {
  const {
    rule,
    columns,
    groupBy,
    pageIndex = 1,
    pageSize = 100,
    orderBy,
    orderDirection = '',
  } = params;
  const { viewer } = useTeiaViewerContext();
  const twin = useTwinSource();
  const client = viewer.twinApiClient;

  const { data, isLoading, isFetching, error } = useQuery({
    queryKey: teiaQuantityTakeoffQueryKeys.objects(
      rule,
      columns,
      groupBy ?? '',
      pageIndex,
      pageSize,
      orderDirection,
      orderBy,
    ),
    queryFn: async () => {
      const { data, ...restResponse } = await TwinApi(client).searchExport(
        twin,
        {
          rule: rule,
          columns: columns,
          group: groupBy ?? '',
        },
        pageIndex,
        pageSize,
        orderBy,
        orderDirection,
      );
      const flatTakeoffObjects = teiaQuantityTakeoffObjectsDTO(data.datas, groupBy);

      return {
        data: flatTakeoffObjects,
        ...restResponse,
      };
    },
    placeholderData: keepPreviousData,
  });

  return {
    data,
    isLoading: isLoading || isFetching,
    error,
  };
};
